export  function UpdateSecurityKey (securityKey) {
    sessionStorage.setItem("securityKey", securityKey);
}

export function getSecurityKey() {
    const securityKey = sessionStorage.getItem("securityKey");
    return securityKey;
}
